import {CommonService} from '../../services/common.service';
import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import {FormControl} from '@angular/forms';
import {LoadingService} from '../../services/loading.service';
import {LocalStorageService} from '../../services/local-storage.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {ReplaySubject, Subject} from 'rxjs';
import {TableConfig, Types} from '../table-config';
import {TableFiltersService} from '../../services/table-filters.service';

@Component({
  styleUrls: ['./filter-table-dialog.component.scss'],
  templateUrl: './filter-table-dialog.component.html'
})
export class FilterTableDialogComponent implements OnInit, OnDestroy {
  public config: TableConfig;
  public onDestroy: Subject<void>;

  constructor(private commonService: CommonService,
              private loadingService: LoadingService,
              private localStorageService: LocalStorageService,
              private matDialogRef: MatDialogRef<FilterTableDialogComponent>,
              private tableFiltersService: TableFiltersService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.config = Object.assign({}, this.data.config);
    this.onDestroy = new Subject<void>();
  }

  public ngOnInit(): void {
    this.matDialogRef.updateSize('500px', `${window.innerHeight}px`);
    this.initializeConfig();
  }

  public ngOnDestroy(): void {
    this.onDestroy.next();
    this.onDestroy.complete();
  }

  public applyFilter(): void {
    // this.loadingService.show();
    this.matDialogRef.close({
      config: this.config,
      filter: this.tableFiltersService.getFilter(this.config)
    });
  }

  public clearFilter(): void {
    this.config = Object.assign({}, this.tableFiltersService.removeAllFilters(this.config));
    this.localStorageService.clearStorage(`filterItem_${this.config.model}`);
    this.initializeConfig();
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  public compareObjects(option1: any, option2: any): boolean {
    let isEqual = true;
    for (const key of Object.keys(option1)) {
      isEqual = option1[key] === option2[key];
      if (!isEqual) {
        return isEqual;
      }
    }
    return isEqual;
  }

  public initializeConfig(): void {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.config.columns.length; i++) {
      if (this.showElement(this.config.columns[i], 'customSelect')) {
        this.config.columns[i].selectFilterControl = new FormControl();

        this.config.columns[i].filteredSelect = new ReplaySubject<any[]>(1);

        this.config.columns[i].filteredSelect.next(this.config.columns[i].customSelect.slice());

        this.commonService.initializeControls(this.config.columns[i].filteredSelect, this.config.columns[i].selectFilterControl,
          this.onDestroy, this.config.columns[i].customSelect);
      }

      if (this.showElement(this.config.columns[i], 'multipleSelect') || this.showElement(this.config.columns[i], 'select')) {
        this.config.columns[i].selectFilterControl = new FormControl();

        this.config.columns[i].filteredSelect = new ReplaySubject<any[]>(1);

        this.config.columns[i].filteredSelect.next(this.config.columns[i].select.options.slice());

        this.commonService.initializeControls(this.config.columns[i].filteredSelect, this.config.columns[i].selectFilterControl,
          this.onDestroy, this.config.columns[i].select.options);
      }
    }
  }

  public showElement(column: any, type: string): boolean {
    if (column.name === 'actions') {
      return false;
    } else {
      return column.type === Types[type];
    }
  }
}
